// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";

let IndexedDB = {};

let OpenDBRequest = {};

let DB = {};

let Transaction = {};

let ObjectStore = {};

let Request = {};

let Event = {};

let dbCache = {
  contents: undefined
};

function getDbFromEvent(event) {
  let db = dbCache.contents;
  if (db !== undefined) {
    return Primitive_option.valFromOption(db);
  }
  let target = event.target;
  let db$1 = target.result;
  dbCache.contents = Primitive_option.some(db$1);
  return db$1;
}

function getErrorMessageFromEvent(event) {
  try {
    return event["target.error"].message;
  } catch (exn) {
    return "Unknown error occurred";
  }
}

function openDBAndGetRequest(dbName, objectStoreName) {
  let request = window.indexedDB.open(dbName, 1);
  request.onupgradeneeded = event => {
    let db = getDbFromEvent(event);
    db.createObjectStore(objectStoreName, {
      keyPath: "timestamp",
      autoIncrement: true
    });
  };
  return request;
}

function setupDatabase(dbName, objectStoreName, onSuccess, onError) {
  let request = openDBAndGetRequest(dbName, objectStoreName);
  request.onsuccess = event => onSuccess(getDbFromEvent(event));
  request.onerror = event => onError(getErrorMessageFromEvent(event));
}

function addData(db, objectStoreName, data) {
  let transaction = db.transaction([objectStoreName], "readwrite");
  let store = transaction.objectStore(objectStoreName);
  let request = store.add(data, data.timestamp);
  return [
    request,
    transaction
  ];
}

function getAllData(db, objectStoreName, onSuccess) {
  let transaction = db.transaction([objectStoreName], "readonly");
  let store = transaction.objectStore(objectStoreName);
  let request = store.getAll();
  request.onsuccess = param => onSuccess(request.result);
}

export {
  IndexedDB,
  OpenDBRequest,
  DB,
  Transaction,
  ObjectStore,
  Request,
  Event,
  dbCache,
  getDbFromEvent,
  getErrorMessageFromEvent,
  openDBAndGetRequest,
  setupDatabase,
  addData,
  getAllData,
}
/* No side effect */
